// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../roundToNearestMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var roundToNearestMinutes = convertToFP(fn, 1);
export default roundToNearestMinutes;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/roundToNearestMinutes/index.js
// module id = 965
// module chunks = 0